<div class="w-full h-full overflow-y-auto flex flex-col gap-4">
    <div class="h-10 flex items-center justify-center gap-3">

        <div class="relative w-full">
            <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                <lucide-icon [img]="icons.Search"></lucide-icon>
            </div>
            <input noEmoji type="search"
                class="block w-full p-2 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                [(ngModel)]="searchQuery" (input)="filterSchedulesList()" placeholder="Search..." />
        </div>
        <div class="h-full relative">
            <!-- Button -->
            <button id="schoolYearDropdownButton" type="button"
                class="flex items-center justify-center gap-2 px-2 w-full h-full rounded-md border border-gray-300 bg-gray-50 whitespace-nowrap"
                (click)="$event.preventDefault(); toggleSchoolYearDropdown()">
                {{ selectedSchoolYear }}
                <svg class="w-2.5 h-2.5 ms-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 10 6">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="m1 1 4 4 4-4" />
                </svg>
            </button>

            <!-- Dropdown list -->
            <div id="schoolYearDropdown" *ngIf="isSchoolYearDropdownOpen"
                class="absolute top-full mt-1 z-20 divide-y divide-gray-300 bg-orange-50 rounded-md w-full shadow-md">
                <ul class="py-2">
                    <li *ngFor="let year of schoolYears">
                        <a href="#" class="block px-4 py-2 hover:bg-white hover:text-nside-orange-400"
                            (click)="$event.preventDefault(); handleSchoolYearSelect(year);">
                            {{ year }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <button
            *ngIf="canSave()"
            class="min-w-fit px-2 h-full rounded-md bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 hover:from-nside-orange-100 hover:to-nside-orange-200 text-white oswald-font flex items-center justify-center gap-2"
            (click)="$event.preventDefault(); handleBtnClick('create-event');">
            <lucide-icon [img]="icons.Plus"></lucide-icon>
            <p class="hidden xl:block">Add New Event</p>
        </button>
    </div>
    <div class="w-full h-full overflow-y-auto">
        <ng-container *ngIf="filteredSchedulesList.length > 0; else emptyAssessCases">
            <table class="w-full text-left">
                <thead class="oswald-font text-gray-700 uppercase bg-main-background">
                    <tr>
                        <th scope="col" class="px-4 py-3 py-3 w-14">
                            <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                                No.
                            </div>
                        </th>
                        <th scope="col" class="px-4 py-3 w-32 min-w-32">
                            <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                                Type
                                <lucide-icon (click)="$event.preventDefault(); sortList('type_name')" [img]="icons.ArrowUpDown"
                                    size="18"></lucide-icon>
                            </div>
                        </th>
                        <th scope="col" class="px-4 py-3 min-w-48 max-w-96">
                            <div class="flex flex-wrap items-center justify-start gap-1 cursor-pointer whitespace-normal break-words text-wrap text-left">
                                Name
                            </div>
                        </th>
                        <th scope="col" class="px-4 py-3 w-48 min-w-32">
                            <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                                Date Time
                                <lucide-icon (click)="$event.preventDefault(); sortList('start_date')" [img]="icons.ArrowUpDown"
                                    size="18"></lucide-icon>
                            </div>
                        </th>
                        <th scope="col" class="px-4 py-3 w-32 min-w-32">
                            <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                                Duration
                                <lucide-icon (click)="$event.preventDefault(); sortList('duration')" [img]="icons.ArrowUpDown"
                                    size="18"></lucide-icon>
                            </div>
                        </th>
                        <th scope="col" class="px-4 py-3 w-44 min-w-32">
                            <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                                Created By
                                <lucide-icon (click)="$event.preventDefault(); sortList('last_updated_by')" [img]="icons.ArrowUpDown"
                                    size="18"></lucide-icon>
                            </div>
                        </th>
                        <th scope="col" class="px-4 py-3 w-20">
                            <div class="flex items-center justify-start gap-1 cursor-pointer whitespace-nowrap">
                                Actions
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of filteredSchedulesList | paginate: { itemsPerPage: itemsPerPage, currentPage: page }; let i=index;"
                        class="bg-white border-b">
                        <th scope="row" class="px-4 py-4">
                            {{ i + 1 + (page - 1) * itemsPerPage }}
                        </th>
                        <th class="px-4 py-4 font-medium">
                            {{ item.type_name }}
                        </th>
                        <th class="px-4 py-4 font-medium">
                            <p class="whitespace-pre-line break-words overflow-hidden [overflow-wrap:anywhere]">{{ item.name }}</p>
                        </th>
                        <td class="px-4 py-4 whitespace-pre-line">{{ item.start_date | date: 'MM/dd/yyyy' }} - {{
                            item.time }}</td>
                        <td class="px-4 py-4">{{ item.duration}}</td>
                        <td class="px-4 py-4">{{ item.last_updated_user_name }}</td>
                        <td class="px-4 py-4">
                            <div class="flex items-center justify-start gap-1">
                                <button [attr.data-tooltip-target]="'tooltip-' + item.id"
                                    data-tooltip-placement="bottom"
                                    class="w-8 h-8 rounded border-2 border-nside-gray-200 text-nside-gray-200 flex items-center justify-center hover:text-white hover:bg-nside-gray-200"
                                    (click)="$event.preventDefault(); handleBtnClick('event-details', item);">
                                    <lucide-icon [img]="icons.FileText" size="20"></lucide-icon>
                                </button>
                                <div [id]="'tooltip-' + item.id" role="tooltip"
                                    class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg shadow-sm opacity-0 tooltip">
                                    Details
                                    <div class="tooltip-arrow" data-popper-arrow></div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </ng-container>
        <ng-template #emptyAssessCases>
            <div class="w-full text-nside-gray-100 italic">
                Empty List
            </div>
        </ng-template>
    </div>
    <div class="flex justify-between items-center">
        <p>{{ filteredSchedulesList.length }} in total</p>
        <pagination-controls *ngIf="filteredSchedulesList.length > itemsPerPage" (pageChange)="page = $event"
            previousLabel="Prev" nextLabel="Next" class="mt-2"></pagination-controls>
    </div>
</div>